import { CurrentOpenMenu } from '@/pages/Search/SearchPage/types';
import FacetTypes from '@/types/search/enums/facetTypes';
import { FilterAction } from '@/types/SearchFacet';
import { QuickFilterName } from '@/utils/amplitude/analytics/searchPage';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { FacetOptionsPill } from '../FacetOptionsPill/FacetOptionsPill';

type Props = {
    currentOpenMenu?: CurrentOpenMenu;
    onMenuClose: () => void;
    onMenuOpen: (currentMenu: CurrentOpenMenu) => void;
};

export const StylePeriodPill = ({ currentOpenMenu, onMenuClose, onMenuOpen }: Props) => {
    const formatMessage = useAppFormatMessage();
    return (
        <FacetOptionsPill
            currentOpenMenu={currentOpenMenu}
            facetId={FacetTypes.STYLE_PERIOD_ID}
            filterActionChanged={FilterAction.StylePeriodChanged}
            filterActionRemoved={FilterAction.StylePeriodRemoved}
            /* As long as the translation key doesn't change, we can guarantee that this will be a string */
            label={String(formatMessage(['search_facet_title_stylePeriod']))}
            onMenuClose={onMenuClose}
            onMenuOpen={onMenuOpen}
            openMenuId={CurrentOpenMenu.StylePeriod}
            quickFilterName={QuickFilterName.StylePeriod}
        />
    );
};
